// extracted by mini-css-extract-plugin
module.exports = {"container":"Services_container__1lWs0","item":"Services_item__26g9B","name":"Services_name__sOO71","icon":"Services_icon__29de6"};